import Vue from 'vue'
import Router from 'vue-router'

// Service components
import SsoResponseHandler from '@/components/route/screenLogin/SsoResponseHandler'
import CreateSite from '@/components/service/siteManager/CreateSite'
import sitesOverview from '@/components/service/siteManager/SitesOverview'

import UserList from '@/components/service/administration/users/UserList'
// import UserCreate from '@/components/service/administration/users/UserCreate'
// import Orders from '@/components/service/administration/Orders'
import ContentEditor from '@/components/service/administration/ContentEditor'

const CampaignCreator = () => import('@/components/service/campaignManager/CampaignCreator')
const PostSubmission = () => import('@/components/service/campaignManager/campaignFields/PostSubmission')
import CampaignPreview from '@/components/service/campaignManager/CampaignPreview'
import CampaignEditor from '@/components/service/campaignManager/CampaignEditor'
import CampaignViewer from '@/components/service/campaignManager/CampaignViewer'
import CampaignCategory from '@/components/service/campaignManager/CampaignCategory'
import SearchResoult from '@/components/service/search/SearchResoult'
// import CampaignTimeline from '@/components/service/campaignManager/CampaignTimeline'

import PostViewer from '@/components/service/postManager/PostViewer'
import PostEditor from '@/components/service/postManager/PostEditor'

// const ConnectAnalyticsHtags = () => import('@/components/service/onboarding/ConnectAnalyticsHtags')
const ConnectEmailMarketing = () => import('@/components/service/onboarding/ConnectEmailMarketing')
// const ConnectMarketingChannels = () => import('@/components/service/onboarding/ConnectMarketingChannels')
const ConnectShop = () => import('@/components/service/onboarding/ConnectShop')
const ConnectSocialMedia = () => import('@/components/service/onboarding/ConnectSocialMedia')
const ConnectShopFailed = () => import('@/components/route/firstTimeSetup/steps/ConnectShopFailed')

const Err404 = () => import('@/components/route/errorRoute/Err404')
const NotAllowed = () => import('@/components/route/errorRoute/NotAllowed')
const ErrorReport = () => import('@/routes/ErrorReport')

// Routes
const Onboarding = () => import('@/routes/Onboarding')

const MainPage = () => import('@/routes/MainPage')
const ErrorRoute = () => import('@/routes/ErrorRoute')
const Login = () => import('@/routes/Login')
const Logout = () => import('@/routes/Logout')
const User = () => import('@/routes/User')
// import Tutorial from '@/routes/Tutorial'

// Blank router view component - for children and such
const BlankView = () => import('@/components/standard/display/BlankView')

// Services
// import PostViewer from '@/services/PostViewer'
const BusinessDashboard = () => import('@/services/BusinessDashboard')
const UserSettings = () => import('@/services/UserSettings')
// const Purchase = () => import('@/services/Purchase')
const Administration = () => import('@/services/Administration')
const ConnectChannels = () => import('@/services/ConnectChannels')
const ChannelInstructions = () => import('@/components/service/connectChannels/ChannelInstructions')
const Analytics = () => import('@/services/Analytics')
const ComponentViewer = () => import('@/services/ComponentViewer')
// const ChannelMonitor = () => import('@/services/ChannelMonitor')
const Impersonate = () => import('@/services/Impersonate')
// const Subscription = () => import ('@/services/Subscription')

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    // Error routes
    {
      path: 'error',
      component: ErrorRoute,
      children: [
        {
          path: '/not-found',
          component: Err404,
          name: 'Err404',
          meta: {
            tabName: 'Page not found!'
          }
        },

        {
          path: '/not-allowed',
          component: NotAllowed,
          name: 'ErrPerm',
          meta: {
            tabName: 'Page not allowed!'
          }
        }
      ]
    },

    // Main Page
    {
      path: '',
      component: MainPage,
      meta: {
        tabName: 'Qwilink'
      },
      children: [

        // Search resoult
        {
          path: 'search/:query',
          name: 'SearchResoult',
          component: SearchResoult,
          meta: {
            tabName: 'Search results'
          }
        },

        /* {
          path: 'monitoring',
          component: ChannelMonitor,
          meta: {
            tabName: 'Monitor channels',
            disabled: true
          }
        }, */

        // Component viewer
        {
          path: 'components',
          component: ComponentViewer,
          meta: {
            tabName: 'Standard components',
            disabled: 'production'
          }
        },

        // User control panel
        {
          component: User,
          path: 'user',
          redirect: { name: 'userSettings' },
          children: [
            // User information and such
            {
              name: 'userSettings',
              path: 'settings',
              component: UserSettings,
              meta: {
                tabName: 'Settings'
              }
            },
            {
              name: 'userSettingsId',
              path: 'settings/:uuid',
              component: UserSettings,
              meta: {
                tabName: 'Settings',
                permissions: {
                  allOf: {
                    addUsers: true
                  }
                }
              }
            },

            // Connections
            {
              path: 'connections/',
              component: BlankView,
              redirect: { name: 'userConnections' },
              meta: {
                tabName: 'Connections'
              },
              children: [
                // Instructions
                {
                  name: 'channelInstructions',
                  path: 'instructions/:type',
                  component: ChannelInstructions,
                  meta: {
                    tabName: 'Instructions'
                  }
                },
                // Connections
                {
                  name: 'userConnections',
                  path: '',
                  component: ConnectChannels,
                  meta: {
                    tabName: 'Connections'
                  }
                }
              ]
            },

            // // Subscription
            // {
            //   name: 'userSubscription',
            //   path: 'subscription',
            //   component: Subscription,
            //   meta: {
            //     tabName: 'Subscription'
            //   }
            // }
          ]
        },

        {
          name: 'businessDashboard',
          path: '',
          component: BusinessDashboard,
          meta: {
            tabName: 'Dashboard'
          }
        },

        // Campaigns - Viewing and editing
        {
          component: BlankView,
          path: 'campaigns/',
          name: 'campaignManager',
          meta: {
            permissions: {
              eitherOneOf: {
                addCampaigns: true,
                addAdvertisable: true,
                addMediaPlanEvent: true
              }
            }
          },
          children: [
            // Campaign viewing
            {
              component: BlankView,
              path: 'view',
              name: 'campaignViewer',
              redirect: { name: 'viewCampaigns', params: { style: 'grid' } },
              children: [
                {
                  name: 'viewCampaigns',
                  path: 'all/:style?/:mpeId?',
                  component: CampaignViewer,
                  meta: {
                    tabName: 'View your campaigns'
                  }
                },
                
                // Campaign Editor
                {
                  name: 'editCampaign',
                  meta: {
                    tabName: 'Edit a campaign',
                    permissions: {
                      allOf: {
                        addCampaigns: true
                      }
                    }
                  },
                  path: ':id/:view?',
                  component: CampaignEditor
                },

                // Campaign advertisables
                {
                  name: 'editQuickPostGroup',
                  meta: {
                    tabName: 'Edit a campaign',
                    permissions: {
                      allOf: {
                        addCampaigns: true
                      }
                    }
                  },
                  path: 'quickPost/:id/:view',
                  component: CampaignEditor
                }
              ]
            },

            // Campaign preview
            {
              name: 'campaignPreview',
              path: 'preview/:id',
              component: CampaignPreview,
              meta: {
                tabName: 'Campaign preview',
                permissions: {
                  allOf: {
                    addCampaigns: true
                  }
                }
              }
            },

            // Campaign creating
            {
              component: BlankView,
              path: 'create',
              name: 'CampaignCreator',
              redirect: { name: 'selectCategory' },
              meta: {
                tabName: 'Create a campaign',
                permissions: {
                  eitherOneOf: {
                    addCampaigns: true,
                    addAdvertisable: true,
                    addMediaPlanEvent: true
                  }
                }
              },
              children: [
                // Campaign Category selection
                {
                  name: 'selectCategory',
                  meta: {
                    tabName: 'Create a campaign',
                  },
                  path: 'category',
                  component: CampaignCategory
                },

                {
                  meta: {
                    permissions: {
                      addCampaigns: true
                    }
                  },
                  path: 'campaign',
                  component: BlankView,
                  children: [
                    {
                      name: 'createCampaign',
                      meta: {
                        tabName: 'Create a campaign',
                        permissions: {
                          addCampaigns: true
                        }
                      },
                      path: ':category/:id?/:action?',
                      component: CampaignCreator
                    }
                  ]
                },

                {
                  meta: {
                    permissions: {
                      addCampaigns: true
                    }
                  },
                  path: 'quickpost',
                  component: BlankView,
                  children: [
                    {
                      name: 'createQuickPost',
                      path: ':category/:id?/:action?/(with/)?:campaign?',
                      component: PostSubmission,
                      meta: {
                        tabName: 'Create a quickPost',
                        permissions: {
                          addCampaigns: true
                        }
                      }
                    }
                  ]
                },
              ]
            }
          ]
        },

        {
          component: ErrorReport,
          name: 'errorReport',
          path: '/error/',
          meta: {
            tabName: 'Error'
          }
        },

        // Administration
        {
          component: Administration,
          path: 'administration',
          name: 'administration',
          meta: {
            tabName: 'Administration tools',
            permissions: {
              eitherOneOf: {
                addContent: true
              }
            }
          },
          children: [
            {
              name: 'Content',
              meta: {
                tabName: 'Content Editor',
                allOf: {
                  addContent: true
                }
              },
              path: 'content',
              component: BlankView,
              children: [
                {
                  name: 'ContentEditor',
                  meta: {
                    tabName: 'Content Editor'
                  },
                  path: 'edit/:type?',
                  component: ContentEditor
                }
              ]
            },

            {
              name: 'UserList',
              path: 'users',
              component: UserList,
              meta: {
                tabName: 'User list'
              }
            }
          ]
        },
        {
          component: Analytics,
          path: 'analytics',
          name: 'analytics',
          meta: {
            tabName: 'Analytics',
          },
        },  
        // Site management
        {
          meta: {
            tabName: 'Manage your sites'
          },
          path: 'sites/',
          name: 'SiteManager',
          redirect: { name: 'sitesOverview' },
          component: BlankView,
          children: [
            {
              name: 'siteCreate',
              meta: {
                tabName: 'Create a new site'
              },
              path: 'create',
              component: CreateSite
            },
            {
              name: 'sitesOverview',
              meta: {
                tabName: 'Overview your sites'
              },
              path: 'view',
              component: sitesOverview
            }
          ]
        },

        // Advertisables
        {
          component: BlankView,
          path: 'advertisables/',
          name: 'AdvertisableManager',
          redirect: { name: 'postsViewer' },
          meta: {
            tabName: 'Edit post'
          },
          children: [
            {
              name: 'advertisableEditor',
              meta: {
                tabName: 'Edit post',
                permissions: {
                  allOf: {
                    addAdvertisable: true
                  }
                }
              },
              path: 'edit/:postId',
              component: PostEditor
            },

            {
              name: 'postsViewer',
              meta: {
                tabName: 'View posts'
              },
              path: 'view',
              component: PostViewer
            }
          ]
        },

        // Impersonation
        {
          component: Impersonate,
          path: 'impersonate/:id',
          name: 'ImpersonateUser',
          meta: {
            tabName: 'Impersonate user'
          }
        }
      ]
    },

    // Onboarding
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: Onboarding,
      redirect: 'onboarding/connect-shop',
      children: [
        {
          name: 'ConnectShops',
          meta: {
            tabName: 'Connect your shop'
          },
          path: 'connect-shop',
          component: ConnectShop
        },
        {
          name: 'ConnectShopsFail',
          meta: {
            tabName: 'Shop connection failed'
          },
          path: 'connect-shop-failed',
          component: ConnectShopFailed
        },
        {
          name: 'connectSocialMedia',
          meta: {
            tabName: 'Connect social media'
          },
          path: 'connect-social-media',
          component: ConnectSocialMedia
        },
        {
          name: 'connectEmail',
          meta: {
            tabName: 'Connect Email'
          },
          path: 'connect-email-marketing',
          component: ConnectEmailMarketing
        }
      ]
    },

    {
      path: '/auth',
      name: 'ssoAuth',
      meta: {
        tabName: 'Sso login'
      },
      component: SsoResponseHandler
    },
    {
      path: '/auth/sign-in',
      name: 'login',
      meta: {
        tabName: 'Login'
      },
      component: Login
    },
    {
      path: '/auth/sign-out',
      name: 'logout',
      meta: {
        tabName: 'Logout'
      },
      component: Logout
    },
    {
      path: '/auth/sign-up',
      name: 'register',
      meta: {
        tabName: 'Register'
      },
      component: Login
    },
    {
      path: '/auth/password-reset',
      name: 'reset',
      meta: {
        tabName: 'Reset password'
      },
      component: Login
    },
    {
      path: '/auth/confirm-email',
      name: 'confirmEmail',
      meta: {
        tabName: 'Confirm email'
      },
      component: Login
    },
    {
      path: '/sign-in',
      redirect: 'auth/sign-in'
    },
    {
      path: '/sign-out',
      redirect: 'auth/sign-out'
    },
    {
      path: '/sign-up',
      redirect: 'auth/sign-up'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (from.name === to.name) {
      return null
    }

    if (!to.matched.filter(m => m.name === 'Onboarding').length) {
      let el = document.getElementById('mainContent')
      if (el) {
        el.scrollTo(0, 0)
      }
      return null
    }
    return { x: 0, y: 0 };
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js